import { Component, computed, inject, input } from '@angular/core';

import { ChartComponent } from '../../../components/charts/chart.component';
import { AssetAllocation } from '../../../domain/lti/investment-portfolio.domain';
import { AssetGroupAllocationChartService } from './asset-group-allocation-chart.service';

@Component({
  selector: 'td-wb-lti-asset-group-allocation-pie-chart',
  template: '@if (options(); as opts) { <td-wb-chart [options]="opts" /> }',
  styleUrls: ['asset-allocation-chart.scss'],
  imports: [
    ChartComponent
  ]
})
export class AssetGroupAllocationChartComponent {
  private readonly assetGroupAllocationChartService = inject(AssetGroupAllocationChartService);

  readonly assetCategoryGroupAllocations = input<Array<AssetAllocation>>(undefined);
  readonly size = input<number>(180);
  readonly innerSize = input<number>(60);
  readonly animation = input<boolean>(true);

  readonly options = computed<Highcharts.Options | undefined>(() => {
    const assetCategoryGroupAllocations = this.assetCategoryGroupAllocations();
    if (assetCategoryGroupAllocations === undefined) { return undefined; }
    return this.assetGroupAllocationChartService.createChartConfiguration(
      assetCategoryGroupAllocations,
      this.size(),
      this.innerSize(),
      this.animation());
  });
}
